<div class="ui sidebar inverted vertical menu">
    <div class="ui top attached large label flex-space-between">
      Design
      <i class="close link icon"></i>
    </div>
    <div class="grouped fields">
      <div class="item">Theme:</div>
      <div class="field item" (click)="selectStyle(theme.webBrightTheme);">
        <div class="ui radio checkbox">
          <input type="radio" name="example2" [checked]="stylingService.theme === theme.webBrightTheme">
          <label class="colored-label">Web Bright Theme</label>
        </div>
      </div>
      <div class="field item" (click)="selectStyle(theme.webDarkTheme);">
        <div class="ui radio checkbox">
          <input type="radio" name="example2" [checked]="stylingService.theme === theme.webDarkTheme">
          <label class="colored-label">Web Dark Theme</label>
        </div>
      </div>
      <div class="field item" (click)="selectStyle(theme.appClassicTheme);">
        <div class="ui radio checkbox">
          <input type="radio" name="example2" [checked]="stylingService.theme === theme.appClassicTheme">
          <label class="colored-label">App Classic</label>
        </div>
      </div>
      <div class="field item" (click)="selectStyle(theme.desktopBrightTheme);">
        <div class="ui radio checkbox">
          <input type="radio" name="example2" [checked]="stylingService.theme === theme.desktopBrightTheme">
          <label class="colored-label">Desktop Bright Theme</label>
        </div>
      </div>
      <div class="field item" (click)="selectStyle(theme.desktopDarkTheme);">
        <div class="ui radio checkbox">
          <input type="radio" name="example2" [checked]="stylingService.theme === theme.desktopDarkTheme">
          <label class="colored-label">Desktop Dark Theme</label>
        </div>
      </div>
    </div>
  
    <div class="ui top attached large label flex-space-between">
      Color
      <i class="close link icon"></i>
    </div>
    <div class="grouped fields">
      <div class="item">Theme:</div>
      <div class="field item">
        <div class="ui flex-align-center">
          <input type="color" class="input-circle" name="example2" value="{{ stylingService.colorArr[0] }}" (change)="onColorSelect($event, 0);">
          <label class="colored-label">1. Farbe</label>
        </div>
      </div>
      <div class="field item">
        <div class="ui flex-align-center">
          <input type="color" class="input-circle" name="example2" value="{{ stylingService.colorArr[1] }}" (change)="onColorSelect($event, 1);">
          <label class="colored-label">2. Farbe</label>
        </div>
      </div>
    </div>
  </div>
  <div class="overlay">
  </div>